import React, { useState } from 'react';

import Button from '@ui/Button';
import ErrorBoundary from '@ui/ErrorBoundary';
import Flex from '@ui/Flex';

import ChatInterface from './ChatInterface';

interface ChatInterfaceComponentProps {
  onClose?: () => void;
}

/**
 * Wrapper component for the Ask AI chat interface
 * Provides context-aware Ask AI assistant with streaming responses
 */
export default function ChatInterfaceComponent({ onClose }: ChatInterfaceComponentProps) {
  const [errorKey, setErrorKey] = useState(0);

  const fallbackUI = (
    <Flex
      align="center"
      gap="md"
      justify="center"
      layout="col"
      style={{ padding: '2rem', textAlign: 'center', height: '100%' }}
    >
      <h3 style={{ margin: 0, fontSize: '1.25rem', fontWeight: 600 }}>Something went wrong with Ask AI</h3>
      <p style={{ margin: 0, color: '#6b7280' }}>
        Please try refreshing the page or contact support if the problem persists.
      </p>
      <Button
        onClick={() => {
          setErrorKey(prev => prev + 1); // Force re-render by changing key
        }}
        size="sm"
      >
        Try Again
      </Button>
    </Flex>
  );

  return (
    <ErrorBoundary fallback={fallbackUI}>
      <ChatInterface key={errorKey} onClose={onClose} />
    </ErrorBoundary>
  );
}
